import React from 'react';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import math from "mathjs";
import PropTypes from 'prop-types';

export class Sensor extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			tooltipOpen: false
		}
	}
	valueToColor(value) {
		if (value < 0 || value > 1) {
			return "#000";
		}
		var hue = 120 - Math.round(120 * value);

		return "hsl(" + hue + ", 100%, 60%)";
	}
	gaussianCDF(x, mean, std) {
		// Cumulative distribution function of Gaussian distribution
		return (1 + math.erf((x - mean) / (std * math.sqrt(2)))) / 2;
	}

	checkFilter(filter, value) {
		var globalAvg = this.props.normalizer[0];

		switch (filter) {
			case "ALL":
				return true;
			case "ABOVE":
				if (value > globalAvg) return true;
				break;
			case "BELOW":
				if (value < globalAvg) return true;
				break;
			case "LOWEST":
				var low = this.props.normalizer[2];
				if (value < low) return true;
				break;
			default:
				return true;
		}

		return false;
	}

	render() {
		let sensor = this.props.sensor;
		let parentName = null;
		if (sensor.id) {
			if (this.props.nodeMap[sensor.id] && this.props.nodeMap[sensor.id].parent) {
				parentName = this.props.nodeMap[sensor.id].parent.info.name;
			}
		}
		let style = { left: sensor.xpercent + '%', top: sensor.ypercent + '%' };

		// Heatmap
		var heatNode = null;
		var isHidden = false;

		isHidden = sensor.hidden;

		// if (!(sensor.id % 5)) {
		// 	 isHidden = true;
		// }

		var cond =
			(this.props.average >= 0 && this.props.average <= 1) && // Valid heatnodes
			(this.checkFilter(this.props.heatmapFilter, this.props.average)) && // Filtered
			(this.props.showHiddenHeatNodes || (!isHidden)); // Show hidden if editing, else no

		if (cond) {
			var normalizedAverage = this.gaussianCDF(this.props.average, this.props.normalizer[0], this.props.normalizer[1]);
			var glowSize = 2 + Math.ceil(normalizedAverage / 0.2) * 1;
			var glowColor = this.valueToColor(normalizedAverage);
			var sensorSize = this.props.thumbnail && "10px";
			var heatStyle = Object.assign({}, style, {
				backgroundColor: glowColor,
				boxShadow: "0px 0px 16px " + glowSize + "px " + glowColor,
				width: sensorSize,
				height: sensorSize
			});

			heatNode =
				<div
					className={"sensor-heatnode" + ((isHidden) ? " heat-show-hidden" : "")}
					data-tooltip={(this.props.showHiddenHeatNodes) ? ((isHidden) ? "Hidden" : "Visible") : ("Average: " + Math.round(this.props.average * 1000) / 10 + "%")} style={heatStyle}
					onClick={(e) => { this.props.onClickHeatNode(e, sensor.id) }}
				>
				</div>
		}
		if (!this.props.thumbnail) {
			return (
				<React.Fragment>
					{heatNode}
				</React.Fragment>
			);
		} else {
			return (
				<div>
					<div className={"sensor-heatnode" + ((isHidden) ? " heat-show-hidden" : "")} style={heatStyle}
						data-tip data-for={"sensor" + sensor.id}
					/>
					<ReactTooltip id={"sensor" + sensor.id} place="right" type="dark" effect="solid">
						{sensor.name}<br />
						{"Average: " + Math.round(this.props.average * 1000) / 10 + "%"}
						<div>{parentName}</div>
					</ReactTooltip>
				</div>
			);
		}

	}
}
function mapStateToProps(state) {
	return {
		nodeMap: state.overviewReducer.nodeMap
	}
}
function mapDispatchToProps(dispatch) {
	return {
		dispatch
	}
}
Sensor.propTypes = {
	normalizer: PropTypes.array.isRequired,
	sensor: PropTypes.object.isRequired,
	average: PropTypes.number,
	heatmapFilter: PropTypes.string.isRequired,
	showHiddenHeatNodes: PropTypes.bool.isRequired,
	thumbnail: PropTypes.bool.isRequired
}
export default connect(mapStateToProps, mapDispatchToProps)(Sensor);



// WEBPACK FOOTER //
// ./src/components/pages/heatmap/sensor.jsx